import { useState } from "react";

export type MutateArrayState<T> = [T[], (mutation: (s: T[]) => void) => void]

export function useMutateArrayState<T>(initialeStateArray: Array<T> = []): MutateArrayState<T> {
    const [value, setArrayState] = useState<T[]>(Object.assign([], initialeStateArray))

    const mutateState = (mutation: (s: T[]) => void) => {
        const clonedArray = [...value];
        mutation(clonedArray);
        setArrayState(clonedArray);
    };

    return [value, mutateState];
}


// WEBPACK FOOTER //
// ./src/hooks/useMutateArrayState.hook.ts